import Settings from 'src/Settings';
import React from 'react';
import Styles from '../../../Styles';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import AVText from 'src/components/elements/AVText';
import LocationMarker from 'src/components/img/svg/LocationMarker';
import {HomeLocationProps} from 'src/components/elements/descriptor/DescriptorType';
import NotificationUnReadIcon from 'src/components/img/svg/newui/notificationUnReadLogo';
import NotificationIcon from 'src/components/img/svg/newui/notificationLogo';
import Localized from 'src/constants/AppStrings';
import ShopIconPay from 'src/components/img/svg/ShopIconpay';
import GreetingsAndBalanceView from 'src/components/elements/home/GreetingsAndBalanceView';
import {RewardsWrappedComponent} from 'src/components/screens/home/RewardsHoc';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import {Image, Platform, Pressable, StyleSheet, Text, View} from 'react-native';
import MilkIcon from 'src/components/img/svg/newui/milk';
import CoolDrinkIcon from 'src/components/img/svg/newui/cooldrink';
import AwarenessIcon from 'src/components/img/svg/newui/awareness';
import FruitIcon from 'src/components/img/svg/newui/fruit';
import Pay365MenuItemBoilerPlate from '../../../img/svg/menuItemsBoilerplateIcons/365PayMenuItemBoilerPlate';
import {
  quickAddOnsPointsTextStyleDescriptor,
  quickAddOnsProductImageContainerStyleDescriptor,
  quickAddOnsTextStyleDescriptor,
  quickAddOnsViewContainerStyleDescriptor,
} from '../../../elements/cart/descriptor/cart-elements-redesign';
import {RenderRecommendationsListProps} from './types';
import Util from '../../../../Util';
import AccountStore from '../../../../stores/AccountStore';

export function getCampusLocationStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    campusView: {
      display: 'flex',
      flexDirection: 'row',
      maxWidth: '80%',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      marginLeft: Styles.Spacing.m3,
      marginRight: Styles.Spacing.m4,
      minHeight: Styles.MinTouchableArea,
      marginBottom: 10,
    },
    linkLocationBtnStyle: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
      color: '#066DFF',
      textDecorationLine: 'none',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    linkView: {
      alignSelf: 'flex-start',
      borderBottomColor: '#066DFF',
      borderBottomWidth: 1.5,
    },
    descriptionTextFont: {
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
  };
}

export function getScanProductName(): string {
  return Localized.Labels.scan_product;
}

export function getScanProductBtnStyle(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    applyButtonText: {
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontSize: getLayoutDescriber().bodyFontSize(),
      textAlign: 'right',
      fontWeight: '400',
    },
  };
}

export function backGroundColorHomeScreen(): string {
  return Styles.tabBarBackgroundColor;
}
export function locationHeaderName(): string {
  return Localized.Labels.locations;
}

export function locationListIcon(): JSX.Element {
  return <ShopIconPay size={25} />;
}

export function recommendationsBlockRenderItem({
  item,
  index,
  isFirstItem,
  isLastItem,
  onMenuItemPress,
}: RenderRecommendationsListProps): JSX.Element {
  return (
    <Pressable
      role="button"
      onPress={() => onMenuItemPress(item)}
      key={index}
      accessibilityRole="button"
      style={{
        ...(Platform.OS === 'web' ? {} : styles.shadow),
      }}
    >
      <View
        accessible
        style={[
          quickAddOnsViewContainerStyleDescriptor(),
          isFirstItem && styles.firstItem,
          isLastItem && styles.lastItem,
        ]}
      >
        <View>
          {/*<Pressable*/}
          {/*  style={quickAddOnsProductPlusIconStyleDescriptor()}*/}
          {/*  onPress={() => onMenuItemPress(item, true)}*/}
          {/*  hitSlop={Styles.HitSlop_4}*/}
          {/*>*/}
          {/*<PlusSignIcon />*/}
          {/*</Pressable>*/}
          {item.imageUrl ? (
            <Image
              accessible={true}
              accessibilityLabel="Product image"
              accessibilityRole="image"
              aria-label="Product image"
              role="img"
              style={quickAddOnsProductImageContainerStyleDescriptor()}
              source={{uri: item.imageUrl}}
              resizeMode={'cover'}
            />
          ) : (
            getPlaceholderImage()
          )}
        </View>
        <Text
          style={[quickAddOnsTextStyleDescriptor(), styles.font]}
          accessibilityHint="Recommendations product name"
          accessibilityLabel={`${item.productName} product name`}
          aria-label={`${item.productName} product name`}
        >
          {item?.productName}
        </Text>
        <Text
          style={[quickAddOnsPointsTextStyleDescriptor(), styles.font]}
          accessibilityHint="Recommendations product price"
          accessibilityLabel={`${item.productName} product price`}
          aria-label={`${item.productName} product price`}
        >
          {Util.formatCurrency(null, +item.price, AccountStore.getCurrency())}
        </Text>
      </View>
    </Pressable>
  );
}

export function getPlaceholderImage() {
  return <Pay365MenuItemBoilerPlate />;
}

export function linkLocationDropDown(props?: HomeLocationProps): JSX.Element {
  return (
    <>
      <View style={homeLocationHeaderStyleDescriptor().locationMainView}>
        <LocationMarker
          size={Styles.Fonts.f3}
          color={Settings.isRefiveAnd365Pay() && Styles.Colors.PayNew.white01}
        />
      </View>
      <AVText
        style={[
          homeLocationHeaderStyleDescriptor().campusNameText,
          homeLocationHeaderStyleDescriptor().locationText365,
        ]}
        numberOfLines={1}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
      >
        {props.locationNameText}
      </AVText>
      <FontAwesome5Pro
        accessible={true}
        accessibilityLabel={
          'Down arrow icon, Double tap to the Locations Screen'
        }
        aria-label={'Down arrow icon, Double tap to the Locations Screen'}
        name="chevron-down"
        color={Styles.Colors.PayNew.white01}
        size={Styles.Heights.touchTargetHeight0}
        style={[homeLocationHeaderStyleDescriptor().campusArrow]}
        testID="qa_dpd_SelectLocation"
      />
    </>
  );
}

export function greetingBalanceRewardsView(
  shortcutBar: JSX.Element,
  _data?: {
    [index: string]: {[index: string]: number | string};
  },
  location?: string,
  trackerSlot?: JSX.Element,
): JSX.Element {
  return (
    <>
      {shortcutBar}
      {trackerSlot}
      <GreetingsAndBalanceView />
      {location && <RewardsWrappedComponent data={_data} />}
    </>
  );
}
export function readUnreadNotificationIcon(
  props?: HomeLocationProps,
): JSX.Element {
  return (
    <>
      {props.readOrUnreadNotificaton ? (
        <NotificationUnReadIcon
          color={
            Settings.isRefiveAnd365Pay()
              ? Styles.Colors.PayNew.white01
              : '#003349'
          }
          size={Styles.Fonts.f4 + 6}
        />
      ) : (
        <NotificationIcon
          color={
            Settings.isRefiveAnd365Pay()
              ? Styles.Colors.PayNew.white01
              : '#003349'
          }
          size={Styles.Fonts.f3}
        />
      )}
    </>
  );
}

export function homeLocationHeaderStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    campusNameText: {
      marginLeft: Styles.Spacing.m0,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
      color: Styles.white,
      fontFamily: Styles.FontFamily.robotoRegular,
      flexShrink: 1,
    },
    campusArrow: {
      marginLeft: Styles.Spacing.m2,
      marginBottom: 4,
    },
    locationMainView: {
      marginBottom: 4,
    },
    locationText365: {
      color: Styles.white,
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontSize: getLayoutDescriber().headerFontSize(),
      fontWeight: '700',
      marginBottom: 4,
    },
  };
}

export function getLocationEmptyIcons() {
  return {
    milk: <MilkIcon fill={getLayoutDescriber().primaryColor()} />,
    coolDrink: <CoolDrinkIcon fill={getLayoutDescriber().primaryColor()} />,
    awareness: <AwarenessIcon fill={getLayoutDescriber().primaryColor()} />,
    fruit: <FruitIcon fill={getLayoutDescriber().primaryColor()} />,
  };
}

export function getTileButton(
  buttonText: string,
  handleClick: () => void,
  disabled?: boolean,
): JSX.Element {
  return null;
}

export function shortCutButtonBorderColor(): string {
  return Styles.Colors.PayNew.brightGray;
}

const styles = StyleSheet.create({
  firstItem: {
    marginLeft: Styles.Spacing.m3,
  },
  shadow: {
    shadowColor: '#000',
    shadowOffset: {width: 2, height: 4},
    shadowOpacity: 0.08,
    shadowRadius: 2,
    elevation: 2,
    marginBottom: Styles.Spacing.m1,
    minHeight: Styles.MinTouchableArea,
  },
  lastItem: {
    marginRight: Styles.Spacing.m3,
  },
  font: {
    fontFamily: Styles.FontFamily.gothamRegular,
    color: Styles.Colors.PayNew.black01,
  },
  quickAdd: {
    backgroundColor: Styles.Colors.Aramark.black01,
    alignItems: 'center',
    borderRadius: Styles.Spacing.m2,
    justifyContent: 'center',
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
    alignSelf: 'center',
    width: 110,
    height: 110,
  },
});

export default {
  getScanProductName,
  getScanProductBtnStyle,
  getCampusLocationStyles,
  backGroundColorHomeScreen,
  homeLocationHeaderStyleDescriptor,
  linkLocationDropDown,
  locationHeaderName,
  readUnreadNotificationIcon,
  locationListIcon,
  greetingBalanceRewardsView,
  getLocationEmptyIcons,
  getTileButton,
  getTrackerPlacement: () => 'top',
  shortCutButtonBorderColor,
  recommendationsBlockRenderItem,
  getPlaceholderImage,
};
